import { render, staticRenderFns } from "./EmailNotificationsSettingsPropertyList.vue?vue&type=template&id=6ac73a9a&"
import script from "./EmailNotificationsSettingsPropertyList.vue?vue&type=script&lang=js&"
export * from "./EmailNotificationsSettingsPropertyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports